// extracted by mini-css-extract-plugin
export default {"container":"AppLoader_container__mhpzD","loader":"AppLoader_loader__s7grF"};